import React from 'react';
import PropTypes from 'prop-types';
import { toast } from 'react-toastify';
import styles from './styles.css';
import 'react-toastify/dist/ReactToastify.css';

class Notification extends React.Component {
  static propTypes = {
    messageType: PropTypes.oneOf(['error', 'warning', 'success', 'info']).isRequired,
    message: PropTypes.string.isRequired,
  };

  static getIcon(messageType) {
    switch (messageType) {
      case 'error':
        return '/images/app/circle-error.svg';
      case 'success':
      default:
        return '/images/app/circle-success.svg';
    }
  }

  static success(message) {
    toast.info(<Notification message={message} messageType="success" />, {
      className: `${styles.toast} ${styles.success}`,
    });
  }

  static error(message) {
    toast.error(<Notification message={message} messageType="error" />, {
      className: `${styles.toast} ${styles.error}`,
    });
  }

  render() {
    const { messageType, message } = this.props;
    return (
      <>
        <img src={Notification.getIcon(messageType)} alt={messageType} />
        <span
          className={styles.text}
          // eslint-disable-next-line react/no-danger
          dangerouslySetInnerHTML={{ __html: message }}
        />
      </>
    );
  }
}

module.exports = Notification;
